import _ from 'lodash';

import {headOption} from 'utils/common';

import {
  selectTenancy,
  selectRentSchedule,
  selectDepositSchedule,
  selectOneOffSchedule,
  SCHEDULE_TYPES
} from 'ducks/tenancy';

export const selectBookingRoomTypeRef = state => {
  const tenancy = selectTenancy(state);
  return _.get(tenancy, 'room.roomType.ref');
};

export const selectCurrentBalance = (state, scheduleType) => {
  const schedule = selectSchedule(state, scheduleType);

  const highlightedRows = _.get(schedule, 'schedule', [])
    .filter(row => row.highlighted)
    .map(x => x.balance);

  return _.head(highlightedRows) || 0;
};

export const selectSchedule = (state, scheduleType) => {
  if (scheduleType === SCHEDULE_TYPES.RENT) {
    return selectRentSchedule(state);
  }
  if (scheduleType === SCHEDULE_TYPES.DEPOSIT) {
    return selectDepositSchedule(state);
  }
  if (scheduleType === SCHEDULE_TYPES.ONE_OFF_CHARGE) {
    return selectOneOffSchedule(state);
  }
  throw Error(`Schedule type is not recognised: ${scheduleType}`);
};

export const selectTenancyId = state => {
  const tenancy = selectTenancy(state);
  return _.get(tenancy, 'id');
};

export const selectTenancyPeriod = state => {
  const tenancy = selectTenancy(state);
  return _.get(tenancy, 'period');
};

export const selectPrimaryTenant = state => {
  const tenancy = selectTenancy(state);
  const tenants = _.get(tenancy, 'tenants', []);

  return headOption(tenants.filter(t => t.isPrimary));
};
